import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-684bf161"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-index" }
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Portrait ", -1))
const _hoisted_4 = { class: "head-portrait" }
const _hoisted_5 = { class: "preview-cover van-ellipsis" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Username ", -1))
const _hoisted_7 = { class: "head-portrait" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Personal Info ", -1))
const _hoisted_9 = { class: "head-portrait" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Interested ", -1))
const _hoisted_11 = { class: "head-portrait" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Update Profile",
      backgroundColor: "#000",
      fontColor: "#fff",
      menuState: ""
    }),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_van_uploader, {
            ImagePreview: false,
            modelValue: $setup.fileList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.fileList) = $event)),
            "after-read": $setup.afterRead,
            "max-count": 1
          }, {
            "preview-cover": _withCtx(({  }) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_van_icon, { name: "search" })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "after-read"]),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20"
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString($setup.userInfo.username), 1)
      ]),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.amendClick('/my-profile')))
      }, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20"
          })
        ])
      ]),
      _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.amendClick('/interrested')))
      }, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20"
          })
        ])
      ])
    ])
  ]))
}